import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCollaborationAction } from '../../Redux/Actions/CollaborationActions';
import { Spinner } from 'react-bootstrap';

const CGoverment = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const collaborationList = useSelector((e) => e?.CollaborationReducer?.collaborationList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllCollaborationAction())
    }

    return (
        <section>

            <h4 className="mb-4 text-black">List of Goverment Collaborations</h4>

            {
                isLoading ?
                    <div className='text-center'>
                        <Spinner animation="border" />
                    </div>
                    :

                    <div className="table-responsive">
                        <table className="table table-striped table-hover" >
                            <thead className="table-secondary">
                                <tr>
                                    <th>S. No.</th>
                                    <th>Geography</th>
                                    <th>Name of State</th>
                                    <th>Name of City</th>
                                    <th>Name of Organization / Institute</th>
                                    <th>Type</th>
                                    <th>Subject Area of Partnership</th>
                                </tr>
                            </thead>

                            <tbody>
                                {collaborationList?.map((row, index) => ( 
                                    <tr key={row.id}>
                                        <td>{index + 1}</td>
                                        <td>{row.geography}</td>
                                        <td>{row.state}</td>
                                        <td>{row.city}</td>
                                        <td>{row.organization}</td>
                                        <td>{row.type}</td>
                                        <td>{row.subject}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

            }

        </section>
    );
};

export default CGoverment;